module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/fontawesome-webfont.woff2?v=4.6.3
// module id = 15
// module chunks = 0